import * as d3 from 'd3'

export default {

  methods: {

    draw_Table() {
      let box = this.table.box
      let header = this.table.header
      let val = this.table.value

      let Table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.title.height + box.padding})`)

      Table
      .append('rect')
      .attr('x', 0).attr('y', 0)
      .attr('width', box.width).attr('height', box.height)
      .attr('fill', box.color)
      .attr('opacity', box.opacity)
      .attr('rx', box.radius).attr('ry', box.radius)

      this.columns.filter(f=> f.code != 'PROG').forEach((d,i)=> {

        Table
        .append('text')
        .attr('x', d.mx).attr('y', header.y + header.tSize*0.75)
        .attr('fill', header.tColor).attr('font-size', header.tSize)
        .attr('text-anchor', 'middle')
        .attr('font-family', 'roboto')
        .text(d.name)

        Table
        .append('text')
        .attr('id', `VAL_${this.localId}_${i}`)
        .attr('x', d.tx).attr('y', val.y + d.tSize*0.75)
        .attr('fill', d.tColor).attr('font-size', d.tSize)
        .attr('text-anchor', d.align)
        .attr('font-family', 'roboto')
        .text(this.gmx_numFormat(this.rawData[d.code], d.unit))
        .call(this.event_Link, d)
      }) 
    },

  } 
}